import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import PatientDetailsBody from "components/ClinicalManagement/Patients/PatientDetailsBody";

const PatientDetails = () => {
  useEffect(() => {
    document.title = "Patient Details";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <PatientDetailsBody />
    </main>
  );
};

export default PatientDetails;
